<template>
  <div class="sf-level">
    <SfToggle :model-value="showPdfViewer" @click="uiStore.togglePdfViewer" />
    <div class="text-left">
      <span>
        {{
          I18n.t('reconciliation_proposal.actions.show_documents', {
            count: documentsCount,
          })
        }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfToggle from '@app/shared/vue/components/sf-toggle.vue'
import { usePdfViewer } from '@app/application/reconciliation_proposal/stores/pdf-viewer'
import { storeToRefs } from 'pinia'

const uiStore = usePdfViewer()
const { showPdfViewer } = storeToRefs(uiStore)
const I18n = window.I18n

interface Props {
  documentsCount: number
}

defineProps<Props>()
</script>
